var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"Component",staticClass:"c-accordion-group"},[_vm._t("default",null,null,{ hasFocus: _vm.hasFocus, method: { openAll: _vm.openAll, closeAll: _vm.closeAll } })],2)
}
var staticRenderFns = []

export { render, staticRenderFns }